import { motion } from "framer-motion";

const QR_SRC = "https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=https://orderhalal.ai";

const QrCode = () => {
  return (
    <section className="relative py-24 md:py-32 border-t border-line" data-testid="qr-section">
      <div className="max-w-7xl mx-auto px-4 md:px-8 flex flex-col items-center text-center">
        <span className="text-terra font-heading text-sm font-semibold tracking-widest uppercase">Take us with you</span>
        <h2 className="mt-4 font-heading text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-cream max-w-xl">
          Point your camera and you're on our site.
        </h2>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="mt-12 bg-white rounded-2xl p-5 shadow-lg"
          data-testid="qr-card"
        >
          <img
            src={QR_SRC}
            alt="QR code linking to orderhalal.ai"
            width={220}
            height={220}
            className="w-[220px] h-[220px] block"
            data-testid="qr-image"
          />
        </motion.div>

        <p className="mt-6 text-base text-sand" data-testid="qr-caption">
          Scan to visit our website
        </p>
      </div>
    </section>
  );
};

export default QrCode;
